import type { IconName } from '@/app_components/icons/constants';
import { MyAccountPages, MyAccountPageTitles } from '@/app_lib/types/accounts/MyAccount';

// TODO: These things should probably becoming from our API instead
export const fortuneSocialLinks: { href: string; icon: IconName; id: string }[] = [
  {
    href: 'https://www.facebook.com/FortuneMagazine/',
    icon: 'Facebook',
    id: 'facebook',
  },
  {
    href: 'https://twitter.com/FortuneMagazine/',
    icon: 'Twitter',
    id: 'twitter',
  },
  {
    href: 'https://www.linkedin.com/company/fortune-magazine/',
    icon: 'LinkedIn',
    id: 'linkedin',
  },
  {
    href: 'https://www.instagram.com/fortunemag/',
    icon: 'Instagram',
    id: 'instagram',
  },
  {
    href: 'https://www.pinterest.com/fortunemagazine/',
    icon: 'Pinterest',
    id: 'pinterest',
  },
];

export const MyAccountLinks = [
  {
    href: '/account/my-profile/',
    id: MyAccountPages.Profile,
    label: MyAccountPageTitles[MyAccountPages.Profile],
  },
  {
    href: '/account/subscriptions/',
    id: MyAccountPages.Subscriptions,
    label: MyAccountPageTitles[MyAccountPages.Subscriptions],
  },
  {
    href: '/account/billing/',
    id: MyAccountPages.Billing,
    label: MyAccountPageTitles[MyAccountPages.Billing],
  },
  {
    href: '/my-account/newsletters/',
    id: MyAccountPages.Newsletters,
    label: MyAccountPageTitles[MyAccountPages.Newsletters],
  },
];

// For Binance Ticker
export const cryptoSectionSlugs = ['crypto', 'guide-hub', 'the-coins', 'companies', 'regulators', 'nfts-and-culture'];

export const noAdArticles = ['Personal Finance Evergreen', 'Health Evergreen'];
export const noRightRailAdArticlesSections = ['personal-finance', '/section/personal-finance/'];
export const noInstreamAdArticles = ['No InStream Ads'];

export const placeholderFortuneImage = 'https://content.fortune.com/wp-content/uploads/2020/09/placeholder_16x9.jpg';

export const PREVIEW_COOKIE_NAME = '__fortune_preview';
export const WORDS_PER_MINUTE_200 = 200;
export const WORDS_PER_MINUTE_300 = 300;
export const WORDS_PER_MINUTE_400 = 400;
export const MAX_READ_TIME = 4;
